module.exports = __webpack_public_path__ + "9779d9a1/img/share-action-icon.9c12578c.svg";